import styled from 'styled-components';
import { Theme } from '@veneer/theme';
import { Modal } from '@veneer/core';

// Overrides Veneer Modal's default padding and internal spacing.
// && doubles specificity to beat Emotion's single-class rules.
export const StyledModal = styled(Modal)<{ $veneerTheme: Theme }>`
  && {
    max-width: 526px;
    width: 100%;
    padding: ${({ $veneerTheme }) =>
      `calc(${$veneerTheme.layout.size8} + ${$veneerTheme.layout.size2}) ${$veneerTheme.layout.size8} ${$veneerTheme.layout.size8} ${$veneerTheme.layout.size8}`};
  }

  > div:last-of-type {
    padding-top: ${({ $veneerTheme }) => $veneerTheme.layout.size5};
  }
`;

export const StyledList = styled.ul<{ $veneerTheme: Theme }>`
  list-style-type: disc;
  padding-left: ${({ $veneerTheme }) => $veneerTheme.layout.size6};
`;
